import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },

    themes: {
      light: {
        primary: "#2B4C59",
        important: "#C5864A",
        secondary: "#1b699b",
        background: "#333333",
        btn_background: "#575B4D",
        text_background: "#EDE5DD",
        poi_background: "#485045",
        route_background: "#38443C",

        accent: "#dad19d",
        error: "#FF5252",
        info: "#2196F3",
        success: "#8bc541",
        warning: "#FFC107",
        grey: "#e7e7e7",
        darkgrey: "#808080",
        lightgray: "#AEAEAE",
      },
    },
  },
});
